const letters = [
	'a',
	'b',
	'e',
	'k',
	'm',
	'h',
	'o',
	'p',
	'c',
	't',
	'y',
	'x',
	'а',
	'в',
	'е',
	'к',
	'м',
	'н',
	'о',
	'р',
	'с',
	'т',
	'у',
	'х',
];
const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

const PlatePattern = 'ldddll';

export { letters, digits, PlatePattern };
